<template>
<!DOCTYPE html>
<html>
<title>W3.CSS</title>
<meta name="viewport" content="width=device-width, initial-scale=1">

<body>
<h1>side nav</h1>
</body>
</html>
</template>
<script>
import producPage from './producPage.vue'

export default{
    name:"sidenav",
    components:{
        producPage
    }
}
</script>

<style>

</style>
